import { useEffect, useReducer } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { isJSON } from "../../utils";
import { getTableState } from "../../utils/localStorage";

const searchParamsReducer = (state, action = {}) => {
	const { type, dataIndex, payload = {} } = action;
	const { valueIndex, valueItem, defaultSearchType, operator, defaultOperator, order, fetchList } =
		payload;
	const initialFilterValue = { value: undefined, searchType: defaultSearchType };
	switch (type) {
		case "CHANGE_FILTER_VALUE":
			state.filter ??= {};
			let filterItem = state.filter[dataIndex] ?? {
				values: [initialFilterValue]
			};
			let values = filterItem.values;

			//change value
			if (values.length > valueIndex) {
				values[valueIndex] = { ...values[valueIndex], ...valueItem };
			}
			const firstFilter = values?.[0];
			//add second filter
			if (values.length === 1 && firstFilter?.value) {
				values = [firstFilter, initialFilterValue];
				filterItem.operator = defaultOperator;
			}
			//remove second filter
			if (values.length === 2 && !firstFilter?.value) {
				values = [firstFilter];
				filterItem.operator = undefined;
			}

			filterItem.values = values;
			state.filter[dataIndex] = filterItem;
			const result = {
				...state,
				filter: { ...state.filter }
			};
			return result;

		case "CHANGE_FILTER_OPERATOR":
			state.filter[dataIndex].operator = operator;
			return {
				...state
			};

		case "SET_SEARCH_PARAMS":
			return {
				...state,
				...payload
			};

		case "CLEAR_SEARCH_PARAMS":
			return {};

		case "REMOVE_FILTER_ITEM":
			const stateCopy = { ...state };
			Object.keys(stateCopy.filter ?? {}).length === 1
				? delete stateCopy.filter
				: delete stateCopy.filter[dataIndex];
			return stateCopy;

		case "CHANGE_SORT":
			const sorts = [...(state.sorts ?? [])];
			const orderDict = {
				ascend: 1,
				descend: -1
			};

			let isDataIndexExist = false;
			for (const sortItem of sorts) {
				if (Array.isArray(sortItem) && sortItem.length > 0 && sortItem[0] === dataIndex) {
					sortItem[1] = orderDict[order];
					isDataIndexExist = true;
				}
			}
			if (!isDataIndexExist) sorts.push([dataIndex, orderDict[order]]);

			if (typeof fetchList === "function") fetchList({ search: state.filter, sorts, page: 1 });
			return { ...state, sorts };

		case "REMOVE_SORTS":
			const stateCopy1 = { ...state };
			delete stateCopy1.sorts;
			if (typeof fetchList === "function") fetchList({ search: stateCopy1.filter, page: 1 });
			return stateCopy1;

		default:
			return state;
	}
};

const useSearchParams = ({ fetchList, tablePrefix }) => {
	const location = useLocation();
	const history = useHistory();

	// const [searchParams, setSearchParams] = useState({});
	const [searchParams, dispatch] = useReducer(searchParamsReducer, {});

	//set state
	useEffect(() => {
		const params = new URLSearchParams(location.search);
		const newParams = {};
		params.forEach((value, key) => (newParams[key] = isJSON(value) ? JSON.parse(value) : value));
		// setSearchParams(newParams);
		dispatch({ type: "SET_SEARCH_PARAMS", payload: newParams });
		if (fetchList && Object.keys(newParams).length > 0) {
			const { page, pageSize } = getTableState(tablePrefix) ?? {};
			fetchList({
				search: newParams.filter,
				page: page ?? 1,
				pageSize,
				...newParams
			});
		}
		// URL-аас анхны параметрийг зөвхөн mount дээр нэг удаа уншина.
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	//set search params
	useEffect(() => {
		const params = new URLSearchParams();
		Object.entries(searchParams).forEach(([key, value]) => {
			const newVal = typeof value === "object" ? JSON.stringify(value) : value;
			params.set(key, newVal);
		});
		history.push({ ...location, search: params.toString() });
		//eslint-disable-next-line
	}, [searchParams]);

	// const setSearchParams = payload => dispatch({ type: "SET_SEARCH_PARAMS", payload });
	const handleChangeFilterValue = ({
		dataIndex,
		valueIndex,
		valueItem,
		defaultSearchType = "equals"
	}) => {
		const value = valueItem?.value;
		if (typeof value === "number") defaultSearchType = "equals";
		else if (Date.parse(value) === "number") defaultSearchType = "inrange";

		dispatch({
			type: "CHANGE_FILTER_VALUE",
			dataIndex,
			payload: {
				valueIndex,
				valueItem,
				defaultSearchType,
				defaultOperator: "and"
			}
		});
	};

	const handleChangeFilterOperator = ({ dataIndex, value }) => {
		dispatch({
			type: "CHANGE_FILTER_OPERATOR",
			dataIndex,
			payload: {
				operator: value
			}
		});
	};

	const handleChangeSorter = (dataIndex, order) => {
		if (!dataIndex || !order)
			return dispatch({
				type: "REMOVE_SORTS",
				payload: {
					fetchList
				}
			});

		return dispatch({
			type: "CHANGE_SORT",
			dataIndex,
			payload: {
				order,
				fetchList
			}
		});
	};

	const resetFilter = dataIndex => dispatch({ type: "REMOVE_FILTER_ITEM", dataIndex });
	const resetSearchParams = () => dispatch({ type: "CLEAR_SEARCH_PARAMS" });

	return {
		searchParams,
		// setSearchParams,
		handleChangeFilterValue,
		handleChangeFilterOperator,
		handleChangeSorter,
		resetFilter,
		resetSearchParams
	};
};

export default useSearchParams;
